import { Button } from '@/components/ui/button'
import { Link } from 'react-router-dom'

export default function HomePage() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="border-b">
        <div className="container mx-auto px-6 py-4 flex items-center justify-between">
          <h1 className="text-2xl font-bold text-primary">Orçamento Solis</h1>
          <div className="flex gap-4">
            <Button variant="ghost" asChild>
              <Link to="/auth/login">Entrar</Link>
            </Button>
            <Button asChild>
              <Link to="/auth/register">Cadastrar</Link>
            </Button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <main className="flex-1 container mx-auto px-6 py-16">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6">
            Sistema de Gestão de Orçamento
          </h2>
          <p className="text-xl text-muted-foreground mb-8">
            Gerencie seu orçamento previsto, sincronize com Pipefy e tenha controle total das suas finanças.
          </p>
          <div className="flex gap-4 justify-center">
            <Button size="lg" asChild>
              <Link to="/auth/register">Comece Agora</Link>
            </Button>
            <Button size="lg" variant="outline" asChild>
              <Link to="/auth/login">Já tenho uma conta</Link>
            </Button>
          </div>
        </div>

        {/* Features */}
        <div className="grid md:grid-cols-3 gap-8 mt-16">
          <div className="p-6 border rounded-lg bg-card">
            <h3 className="text-xl font-semibold mb-3">Gestão de Orçamento</h3>
            <p className="text-muted-foreground">
              Controle total do orçamento previsto com importação de planilhas e análise detalhada.
            </p>
          </div>
          <div className="p-6 border rounded-lg bg-card">
            <h3 className="text-xl font-semibold mb-3">Integração Pipefy</h3>
            <p className="text-muted-foreground">
              Sincronização automática com Pipefy para comparar previsto vs realizado.
            </p>
          </div>
          <div className="p-6 border rounded-lg bg-card">
            <h3 className="text-xl font-semibold mb-3">Relatórios e Análises</h3>
            <p className="text-muted-foreground">
              Dashboards interativos e relatórios SQL para análise financeira completa.
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t">
        <div className="container mx-auto px-6 py-8">
          <div className="text-center text-sm text-muted-foreground">
            © 2024 Orçamento Solis. Todos os direitos reservados.
          </div>
        </div>
      </footer>
    </div>
  )
}

